"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var buildListItem = function buildListItem(name, value) {
  return '<li role="presentation"><a class="fr-command" role="option" data-cmd="mergeFields"' + "data-param1=\"".concat(value, "\" title=\"").concat(name, "\">").concat(name, "</a></li>");
}; // Add Merge Fields button
// Has predefined list of merge fields, which can be replaces by
// passing `mergeFields` custom option:
// customOptions: {
//  '{{contact.links.referral}}': 'Referral Link'
// }


var defaultFields = {
  '{{contact.first_name}}': 'First Name',
  '{{contact.last_name}}': 'Last Name',
  '{{contact.name}}': 'Full Name',
  '{{contact.title}}': 'Job Title',
  '{{contact.company}}': 'Company',
  '{{contact.current_points}}': 'Current points',
  '{{contact.total_points}}': 'Lifetime Points',
  '{{contact.level}}': 'Current Level',
  '{{global.community}}': 'Community Name',
  '{{global.company_name}}': 'Your Company Name'
};

var _default = function _default(froala) {
  froala.DefineIconTemplate('customSvg', '<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">[PATH]</svg>');
  froala.DefineIcon('mergeFields', {
    template: 'customSvg',
    PATH: "\n        <path class=\"frc-mergeFieldsButton\" d=\"M363.1,104.7H199.4c-18.1,0-32.8,14.7-32.8,32.8v226.1c0,18.1,14.7,32.8,32.8,32.8h163.6 c18.1,0,32.8-14.7,32.8-32.8V137.4C395.8,119.3,381.2,104.7,363.1,104.7z\"/>\n        <path d=\"M395.8,63h-250c-15.3,0-28.6,8.5-35.8,20.8H83.3c-11.5,0-20.8,9.3-20.8,20.8c0,11.5,9.3,20.8,20.8,20.8h20.8H125h10.4 c5.8,0,10.4,4.6,10.4,10.4c0,5.8-4.6,10.4-10.4,10.4h-31.2v62.5H83.3c-11.5,0-20.8,9.3-20.8,20.8c0,11.5,9.3,20.8,20.8,20.8h20.8 H125h10.4c5.8,0,10.4,4.6,10.4,10.4c0,5.8-4.6,10.4-10.4,10.4h-31.2v62.5H83.3c-11.5,0-20.8,9.3-20.8,20.8 c0,11.5,9.3,20.8,20.8,20.8h20.8H125h10.4c5.8,0,10.4,4.6,10.4,10.4c0,5.8-4.6,10.4-10.4,10.4h-31.2c0,22.9,18.8,41.7,41.7,41.7h250 c22.9,0,41.7-18.8,41.7-41.7V104.7C437.5,81.7,418.7,63,395.8,63z M395.8,363.6c0,18.1-14.7,32.8-32.8,32.8H199.4 c-18.1,0-32.8-14.7-32.8-32.8V137.4c0-18.1,14.7-32.8,32.8-32.8h163.6c18.1,0,32.8,14.7,32.8,32.8V363.6z\"/>\n        <path d=\"M273.7,305.3l-7.4-19.3h-46.2l-7.4,19.3h-20.1l39.6-100.7h22l39.6,100.7H273.7z M243.2,222.4l-18.1,48h36.2L243.2,222.4z\" />\n        <path d=\"M348.9,305.3v-7.9c-5.4,6.2-13.9,9.7-23.5,9.7c-11.9,0-25.4-8-25.4-24.1c0-16.8,13.4-23.7,25.4-23.7 c9.8,0,18.3,3.2,23.5,9.4v-10.9c0-8.5-6.9-13.6-17.1-13.6c-8.2,0-15.2,3-21.6,9.2l-6.5-11c8.5-8,19-11.8,30.6-11.8 c16.2,0,30.4,6.8,30.4,26.4v48.3H348.9z M348.9,288.7v-11c-3.6-5-10.4-7.5-17.4-7.5c-8.9,0-15.6,5.1-15.6,13.1 c0,7.9,6.6,13,15.6,13C338.5,296.3,345.3,293.7,348.9,288.7z\"/>\n      "
  });
  froala.RegisterCommand('mergeFields', {
    title: 'Merge Fields',
    type: 'dropdown',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    options: {},
    callback: function callback(_cmd, val) {
      this.html.insert(val);
    },
    refreshOnShow: function refreshOnShow(_dropdownButton, dropdown) {
      dropdown.find('.fr-dropdown-list li').remove();
      var mergeFields = this.opts.mergeFields && R.not(R.isEmpty(this.opts.mergeFields)) ? this.opts.mergeFields : _objectSpread({}, defaultFields, {}, this.customProfileFieldsPlugin.getCustomProfileFields());
      if (!mergeFields) return '';
      var listItems = '';

      for (var _i = 0, _Object$entries = Object.entries(mergeFields); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        listItems += buildListItem(value, key);
      }

      dropdown.find('.fr-dropdown-list').append(listItems);
    }
  });
};

exports.default = _default;